"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.delayUntilIdle = delayUntilIdle;
var DELAY_TIMEOUT = 5000;

function delayUntilIdle(callback) {
  var delay = window.requestIdleCallback || window.setTimeout;
  var delayOptions = delay === window.requestIdleCallback ? {
    timeout: DELAY_TIMEOUT
  } : 0;
  delay(callback, delayOptions);
}